import { DollarApollo } from "vue-apollo/types/vue-apollo";
import Mutation from "./mutation.gql";

export interface CreateGroupUsersVariables {
  groupId: string;
  input: string;
}

export interface CreateGroupUsersResult {
  name: string;
  email: string;
  role: string;
  loginId: string;
  password: string;
}

export interface RawResult {
  createGroupUsers: CreateGroupUsersResult[];
}

export interface InputError {
  row: number;
  name: "ユーザー名" | "権限" | "メールアドレス";
  message: string;
}

export interface Result {
  data?: CreateGroupUsersResult[];
  errors?: InputError[];
}

export const createGroupUsers = async <V>(
  apollo: DollarApollo<V>,
  variables: CreateGroupUsersVariables
): Promise<Result> => {
  const result = await apollo.mutate<RawResult>({
    mutation: Mutation,
    variables,
    errorPolicy: "all"
  });
  await apollo.provider.defaultClient.cache.reset();

  const data = result.data ? result.data.createGroupUsers : undefined;
  const errors = result.errors
    ? ((result.errors[0]!.extensions!.exception!.errors ||
        []) as InputError[]).sort((a, b) => a.row - b.row)
    : undefined;

  return { data, errors };
};
